export default "/images/a06d9ace33c85708b0b015a23242202a.png";